<template>
  <v-container fluid class="pa-0">
    <PageHeader title="Guidelines" icon="rule" />
    <Subheader v-model="searchText" title="Guidelines" search="guidelines">
      <v-btn color="info" @click="allExpansionOpen()">
        <v-icon class="mr-1">zoom_in</v-icon>
        {{ $t('Button.Expand') }}
      </v-btn>
      <v-btn color="info" @click="allExpansionClose()">
        <v-icon class="mr-1">zoom_out</v-icon>
        {{ $t('Button.Collapse') }}
      </v-btn>
    </Subheader>
    <v-layout v-for="(category,index) in categorized" :key="index">
      <v-flex>
        <v-card>
          <v-card-text v-show="search === null || search === ''" style="padding-left: 24px; font-size: 18px; border-top: 1px solid rgba(0,0,0,.12); border-left: 2px #E8E8E8; border-right: 2px 	#E8E8E8">
            {{category.acronym}}
          </v-card-text>
          <v-expansion-panel focusable expand v-model="category.panelArray">
            <v-expansion-panel-content style="border-top: 1px solid rgba(0,0,0,.12) !important" v-for="g in category.Guidelines" :key="g.Id" v-show="search === null || search === ''|| (search && (showSection.indexOf(g.Id) >= 0 || searchGroup(search, g)))">
              <div slot="header">
                <span class="font-weight-medium">{{g.GuidelineLongName}} ({{g.GuidelineName}})</span>
                <!-- <h4>Feasible Media Types: {{ g.medias.map(x => x.name).join()}}</h4> -->
              </div>
              <v-data-table :headers="headers" :items="g.Standards" :search="search" :filter="(val, search) => { return searchList(val, search, g.Id) || searchGroup(search, g) }" hide-actions class="elevation-1">
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.AnalyteNameInGuideline }}</td>
                  <td class="text-xs-left" v-html="getGuidelineValue(props.item)"></td>
                  <td class="text-xs-left">{{ props.item.Unit }}</td>
                  <template v-if="IsHtml(props.item.ReferenceSource)">
                    <td class="text-xs-left" v-if="linkTo(props.item.ReferenceSource)">
                      <a :href="linkTo(props.item.ReferenceSource)" target="_blank">{{ props.item.ReferenceSource }}</a>
                    </td>
                    <td class="text-xs-left" v-else v-html="props.item.ReferenceSource"></td>
                  </template>
                  <template v-if="!IsHtml(props.item.ReferenceSource)">
                    <td class="text-xs-left" v-html="linkExtract(props.item.ReferenceSource)"></td>
                  </template>
                  <td class="text-xs-left" v-html="props.item.LastModifiedDateTime != null ? formatDate(props.item.LastModifiedDateTime, prettyDateTimeFormat): ''"></td>
                  <td class="text-xs-left" v-html="props.item.Notes"></td>
                  <td class="text-xs-left" v-html="props.item.LastModifiedBy"></td>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { prettyDateTimeFormat, formatDate } from '@/components/mixins/MomentUtil'
  import { AmmoniaLookupTable, LookupTable } from '@/components/mixins/GuidelinesManageUtil'

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const {
    mapGetters,
  } = createNamespacedHelpers('guidelines')

  export default {
    components: {
    },
    data() {
      return {
        prettyDateTimeFormat,
        search: null,
        searchText: null,
        showSection: [],
        hover: 'white',
        headers: [
          { text: 'Analyte', align: 'left', value: 'AnalyteNameInGuideline' },
          { text: 'Guideline', align: 'left', value: 'StandardValue' },
          { text: 'Unit', align: 'left', value: 'Unit' },
          { text: 'Reference', align: 'left', value: 'ReferenceSource' },
          { text: 'Last Modified Date', align: 'left', value: 'LastModifiedDateTime' },
          { text: 'Notes', align: 'left', value: 'Notes' },
          { text: 'Last Modified By', align: 'left', value: 'LastModifiedBy' },
        ],
        categorized: {},
      }
    },
    computed: {
      ...mapGetters({
        'Guidelines': 'guidelineOfCurrentTenant',
      }),
    },
    watch: {
      searchText(newVal) {
        this.showSection = []
        this.search = newVal
        if (this.searchText) {
          this.allExpansionOpen()
        } else {
          this.allExpansionClose()
        }
      },
      Guidelines() {
        this.initializeData()
      },
    },
    methods: {
      formatDate,
      searchList(val, search, guidelineID) {
        var isMatched = false
        if (search === null || search === '') {
          isMatched = true
        } else if (val === null) {
          isMatched = false
        } else if (val.toLowerCase().indexOf(search.toLowerCase()) >= 0) {
          isMatched = true
          if (this.showSection.indexOf(guidelineID) === -1) {
            this.showSection.push(guidelineID)
          }
        } else {
          isMatched = false
        }
        return isMatched
      },
      searchGroup(search, g) {
        if (g.GuidelineLongName.toLowerCase().indexOf(search.toLowerCase()) >= 0 ||
          g.GuidelineName.toLowerCase().indexOf(search.toLowerCase()) >= 0) {
          return true
        } else {
          return false
        }
      },
      IsHtml(referenceString) {
        if (!referenceString) {
          return true
        } else {
          return referenceString.match('</a>') != null
        }
      },
      linkTo(referenceString) {
        if (referenceString === null) {
          return false
        }
        var result = referenceString.split(' ')
        var loop
        var link = ''
        for (loop = 0; loop < result.length; loop++) {
          if (result[loop].startsWith('http')) {
            link = result[loop]
            return link
          }
        }
        return false
      },
      linkExtract(referenceString) {
        var reg = /\[.*?\]\(.+?\)/g
        var matched = referenceString.match(reg)
        if (matched == null) {
          return '<span>' + referenceString + '</span>'
        } else {
          var nameStr = ''
          var htmlStr = ''
          var index = referenceString.indexOf(matched[0])
          if (index > 0) {
            nameStr = referenceString.substr(0, index)
          }
          matched.forEach(element => {
            let text = element.match(/\[(.+?)\]/)
            let url = element.match(/\((.+?)\)/)
            if (url) {
              url = url[1]
            }
            if (text) {
              text = text[0]
            } else {
              text = '[' + url + ']'
            }
            htmlStr = htmlStr.concat('<a target="_blank" style="color: blue" href="' + url + '">' + text + '</a>')
          })
          htmlStr = '<span>' + nameStr + '</span>' + htmlStr
          return htmlStr
        }
      },
      categorizeGuidelines() {
        var categories = []
        var sortedGuidelines = this.Guidelines.slice()
        sortedGuidelines.sort((a, b) => {
          return a.GuidelineLongName.toLocaleLowerCase().localeCompare(b.GuidelineLongName.toLocaleLowerCase())
        })
        sortedGuidelines.forEach(g => {
          if (g.Category) {
            var acronym = g.Category
            if (categories.findIndex(c => { return c.acronym === acronym }) === -1) {
              var category = {
                acronym: acronym,
                Guidelines: sortedGuidelines.filter(d => { return d.Category === acronym }),
              }
              categories.push(category)
            }
          }
        })
        return categories
      },
      getGuidelineValue(guideline) {
        if(guideline.ValueType == AmmoniaLookupTable) {
          return JSON.parse(guideline.StandardValue).Description
        }
        if(guideline.ValueType == LookupTable) {
          return '<b class="warning">Viewing lookup table guideline value is not supported yet.</b>'
        }
        return guideline.StandardValue.replace('-99999', 'None')
      },
      allExpansionOpen() {
        this.categorized.forEach(e => {
          e.panelArray = [...Array(e.Guidelines.length).keys()].map(() => true)
        })
      },
      allExpansionClose() {
        this.categorized.forEach(e => {
          e.panelArray = []
        })
      },
      initializeData() {
        var data = this.categorizeGuidelines()
        data.forEach(e => {
          e.panelArray = []
        })
        this.categorized = data
      },
    },
    mounted() {
      this.initializeData()
    },
  }
</script>

<style lang="stylus" scoped>
  .toolbar__title.display-2 {
    padding-bottom: 10px;
    margin-left: 10px !important;
  }

  a:link {
    color: #0000EE;
  }

  a:active {
    color: #551A8B;
  }

  a:visited {
    color: #551A8B;
  }
</style>